// The FAST (one-time eGIRO) status page. Matches its route in router/mygiving-routes.js.
export const FAST_STATUS_PATH = '/my-giving/local-transfer-egiro/status';

export const fastStatusPath = transactionId => `${FAST_STATUS_PATH}/${transactionId}`;

// The FAST page charges the eGIRO mandate the member picked on giving-options
// (myGiving/eGiroMandateId). The store isn't persisted, so if the WebView reloads
// while the page is open (iOS reclaiming it in the background, an OTA update) the
// page comes back with no mandate, and a one-time gift went out with
// `egiroRef: null`, which giving-api refuses with a 400 (prod, 4 Oct 2026). With no
// mandate, send the member back to choose their account again instead.
export const FAST_MANDATE_MISSING_MESSAGE =
  'Please choose your bank account again to continue giving.';

/** Whether the page has a mandate to charge: a non-blank string. */
export const hasMandate = eGiroMandateId =>
  typeof eGiroMandateId === 'string' && eGiroMandateId.trim() !== '';
